import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class NotFound extends Component {
    render() {
        return (
            <div className="notfound">
                <p>Page not found.</p>
                <Link to="/">Back to main page</Link>
            </div>
        );
    }
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/NotFound.js